import React, { useState, useContext, useEffect } from "react";
import axios from "axios";
import useEntitesTable from "./useEntitesTable.js";
import FileUpload from "./file-upload.component.jsx";
import UserService from "../../services/UserService";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListSubheader from "@mui/material/ListSubheader";
import Select from "@mui/material/Select";
import { postDataFiles } from "services/ConfigServices"
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { NotificationManager } from 'react-notifications';
import { archiData, billData } from 'variables/lists/imports';


function UploadDialog(props) {
  const currentusertype = localStorage.getItem("userType");
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const [disabled, setDisabled] = useState(false);
  const [templateListArchi, setTemplateListArchi] = useState([]);
  const [templateListBills, setTemplateListBills] = useState([]);

  const { closeModal, refetch, accountTemplates } = props;
  const [token, setToken] = useState("e7557c26-15ec-4548-8a24-08e71987e8e7");

  const [dataType, setDataType] = useState("");

  console.log(disabled);

  const [newDocumentsInfo, setNewDocumentsInfo] = useState({
    documents: [],
  });

  useEffect(() => {
    if (currentusertype == 1) {
      setTemplateListArchi(archiData);
      setTemplateListBills(billData);
    }
    else {
      let templatearchi = [];
      templatearchi = archiData.filter((data) =>
        accountTemplates.includes(data.id)
      );
      setTemplateListArchi(templatearchi);
      let templatebills = [];
      templatebills = billData.filter((data) =>
        accountTemplates.includes(data.id)
      );
      setTemplateListBills(templatebills);
    }

  }, [accountTemplates]);



  const handleDataTypeChange = (event) => {
    setDataType(event.target.value);
  };

  const updateUploadedFiles = (files) =>
    setNewDocumentsInfo({ ...newDocumentsInfo, documents: files });

  const handleSubmit = (event) => {
    setDisabled(true);
    postfiles(event);
    //console.log("test");
  }
  const postfiles = async (event) => {
    //event.preventDefault();

    //J'ai combien de fichiers?
    let size = newDocumentsInfo.documents.length;
    let sent = 0;
    let errors = 0;
    for (const [index, value] of newDocumentsInfo.documents.entries()) {
      //console.log("test1");
      const formData = new FormData();
      // we append each element to the form
      formData.append("files[]", newDocumentsInfo.documents[index]);
      axios
        .post(
          postDataFiles(chartIdGroup, 'DATA', dataType),
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
          sent = sent + 1;
          if (sent + errors == size) {
            NotificationManager.success("Documents ajoutés");
            closeModal();
            refetch();
          } else {

          }
          //Si nombre de réponse reçues = nombre de fichiers
        })
        .catch((err) => {
          errors++;
          if (sent + errors == size) {
            NotificationManager.error("Une erreur est survenue");
            closeModal();
            refetch();
          } else {
            NotificationManager.error("Certains documents n'ont pas pu être envoyés");
            closeModal();
            refetch();
          }
        });
    }
  };

  const useStyles = makeStyles((theme) => ({
    select: {
      display: "flex",
      flexDirection: "column",
      margin: "1rem 0.5rem",
    },
    submitButton: {
      color: "#FFFFFF",
      backgroundColor: "#91C73C",
      fontWeight: "bold",
      display: "block",
      marginTop: "6px",
      marginRight: "auto",
      marginLeft: "0ch",
      width: "60ch",
      "&:hover": {
        backgroundColor: "#91C73C",
        boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
      },
    },
    submitButtonDisabled: {
      color: "#FFFFFF",
      backgroundColor: "#9798A0",
      fontWeight: "bold",
      display: "block",
      marginTop: "6px",
      marginRight: "auto",
      marginLeft: "0ch",
      width: "60ch",
    },
  }));

  const classes = useStyles();

  return (
    <div style={{ minWidth: "400px", overflow: "hidden" }}>
      <div className={classes.select}>
        <text style={{ margin: "0.2rem 0rem" }}>Type de fichier</text>{" "}
        <FormControl variant="outlined">
          <Select
            labelId="dataType-simple-select-outlined-label"
            id="dataType-simple-select-outlined"
            value={dataType}
            onChange={handleDataTypeChange}
          >
            {
              templateListArchi.length > 0 ?
                <ListSubheader>--Données patrimoniales--</ListSubheader> : <></>}
            {templateListArchi.map((param, index) => {
              return (
                <MenuItem value={param.id}>{param.name}</MenuItem>
              );
            })
            }
            {
              templateListBills.length > 0 &&
              <ListSubheader>--Données de consommation/facturation--</ListSubheader>}
            {templateListBills.map((param, index) => {
              return (
                <MenuItem value={param.id}>{param.name}</MenuItem>
              );
            })
            }
          </Select>
        </FormControl>
      </div>
      <form>
        <FileUpload
          accept=""
          //accept=".jpg,.png,.jpeg,.pdf,.csv"
          label="Documents"
          multiple
          updateFilesCb={updateUploadedFiles}
        />
        <Button
          disabled={!dataType || newDocumentsInfo.documents.length === 0 || disabled}
          className={
            (!dataType || newDocumentsInfo.documents.length === 0 || disabled)
              ? classes.submitButtonDisabled
              : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Importer
        </Button>
        {/* <Button
          style={{
            color: "#FFFFFF",
            backgroundColor: (!dataType || newDocumentsInfo.documents.length === 0) ? "#9798A0" : "#91C73C",
            fontWeight: "normal",
            fontWeight: "bold",
            height: "40px",
            fontSize: "0.75rem",
            padding: "5px 15px",
            marginRight: "0px",
            marginBottom: "0px",
            marginTop: "15px",
            fontFamily: '"Source Sans Pro",sans-serif',
            width: "96%",
            marginLeft: "2%",
          }}
          onClick={handleSubmit}
          disabled={!dataType || newDocumentsInfo.documents.length === 0 || disabled}
        >
          Importer
        </Button> */}
      </form>
    </div>
  );
}

export default UploadDialog;
